<template>
  <v-menu v-model="menu" :close-on-content-click="false" offset-y transition="scale-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :id="inputId"
        v-model="inputValue"
        v-bind="attrs"
        v-on="on"
        prepend-inner-icon="mdi-calendar"
        :rules="[validateDate]"
        clearable
        dense
        placeholder="YYYY-MM-DD"
        @keydown="applyMask"
        @keydown.enter.prevent="menu = false"
        @keydown.tab.exact.prevent="handleTabPress"
        @keydown.shift.tab.prevent="handleShiftTabPress"
      />
    </template>

    <v-date-picker v-model="safeValue" @input="menu = false" landscape />
  </v-menu>
</template>

<script lang="ts">
  import Vue from 'vue';
  import { mixins } from '@/mixin/mixins';

  const mask = '####-##-##';

  export default Vue.extend({
    name: 'MuiStyleDatePicker',
    mixins: [mixins],
    props: {
      value: {
        type: String,
        default: '',
      },
      id: {
        type: String,
        default: '',
      },
      nextElementId: {
        type: String,
        default: '',
      },
      prevElementId: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        menu: false,
        inputValue: this.value ?? new Date().toISOString().slice(0, 10),
        inputId: this.id,
      };
    },
    computed: {
      safeValue: {
        get(): string {
          if (isValidDate(this.inputValue)) {
            this.$emit('input', this.inputValue);
            return this.inputValue;
          } else {
            this.$emit('input', null);
            return '';
          }
        },
        set(val: string) {
          this.inputValue = val;
        },
      },
    },
    methods: {
      validateDate(v: string) {
        return isValidDate(v) || 'Invalid Date';
      },
      applyMask(e: KeyboardEvent) {
        const key = e.key ?? '';

        if (key === 'Backspace') {
          return;
        } else {
          e.preventDefault();
        }

        if (!this.inputValue) {
          this.inputValue = '';
        }

        var currIdx = this.inputValue.length;

        if (currIdx >= mask.length) {
          return;
        }

        if (mask[currIdx] === '#') {
          if (key.match(/^\d$/)) {
            this.inputValue += key;
          }
        } else {
          while (currIdx < mask.length && mask[currIdx] !== '#') {
            this.inputValue += mask[currIdx++];
          }
          if (key.match(/\d/)) {
            this.inputValue += key;
          }
        }
      },
      handleTabPress() {
        this.menu = false;
        this.clickElementbyId(this.nextElementId);
      },
      handleShiftTabPress() {
        this.menu = false;
        this.clickElementbyId(this.prevElementId);
      },
    },
  });
  function isValidDate(dateStr: string) {
    if (!dateStr || dateStr.length < 10) {
      return false;
    }

    const date = new Date(dateStr).getTime();

    return isNaN(date) === false;
  }
</script>
